import axios from "axios";
import * as d3 from "d3";
import {responsivefy} from '../functions'

export default function (chart, divId, vizName) {
    var url = '/api/fetchData/' + chart.data.syspk + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // set the dimensions and margins of the graph
    var margin = {
            top: chart.margin.top,
            right: chart.margin.right,
            bottom: chart.margin.bottom,
            left: chart.margin.left
        },
        width = chart.width - margin.left - margin.right,
        height = chart.height - margin.top - margin.bottom;

    // append the svg object to the body of the page
    var svg = d3.select(divId)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // get the data
    axios.get(url).then(res => {
        let data = res.data;

        // add the x and y Axis
        var x1Scale = d3.scaleLinear().domain([-10, 20]).range([0, width]);
        var y1Scale = d3.scaleLinear().range([height, 0]).domain([0, 0.12]);

        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x1Scale));

        svg.append("g").call(d3.axisLeft(y1Scale));

        // Compute kernel density estimation
        var kde = kernelDensityEstimator(kernelEpanechnikov(7), x1Scale.ticks(30))
        var density1 = kde(data.map(function (d) {
            return d.metric1 / 100000;
        }))
        var density2 = kde(data.map(function (d) {
            return d.metric2 / 100000;
        }))

        // Plot the area
        svg.append("path")
            .attr("class", "mypath")
            .datum(density1)
            .attr("fill", "#69b3a2")
            .attr("opacity", ".6")
            .attr("stroke", "#000")
            .attr("stroke-width", 1)
            .attr("stroke-linejoin", "round")
            .attr("d", d3.line()
                .curve(d3.curveBasis)
                .x(function (d) {
                    return x1Scale(d[0]);
                })
                .y(function (d) {
                    return y1Scale(d[1]);
                })
            );

        // Plot the area
        svg.append("path")
            .attr("class", "mypath")
            .datum(density2)
            .attr("fill", "#404080")
            .attr("opacity", ".6")
            .attr("stroke", "#000")
            .attr("stroke-width", 1)
            .attr("stroke-linejoin", "round")
            .attr("d", d3.line()
                .curve(d3.curveBasis)
                .x(function (d) {
                    return x1Scale(d[0]);
                })
                .y(function (d) {
                    return y1Scale(d[1]);
                })
            );
    });

    // Handmade legend
    svg.append("circle").attr("cx", 300).attr("cy", 30).attr("r", 6).style("fill", "#69b3a2")
    svg.append("circle").attr("cx", 300).attr("cy", 60).attr("r", 6).style("fill", "#404080")
    svg.append("text").attr("x", 320).attr("y", 30).text("Seasonal Data").style("font-size", "15px").attr("alignment-baseline", "middle")
    svg.append("text").attr("x", 320).attr("y", 60).text("Trend Data").style("font-size", "15px").attr("alignment-baseline", "middle")

    // Function to compute density
    function kernelDensityEstimator(kernel, X) {
        return function (V) {
            return X.map(function (x) {
                return [x, d3.mean(V, function (v) {
                    return kernel(x - v);
                })];
            });
        };
    }

    function kernelEpanechnikov(k) {
        return function (v) {
            return Math.abs(v /= k) <= 1 ? 0.75 * (1 - v * v) / k : 0;
        };
    }
}
